import { numberToMonth as formatNumberToMonth } from '@shared/utils';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';

export function isoToDayJs(isoDate: string | null | undefined): dayjs.Dayjs | null {
    return isoDate ? dayjs(isoDate) : null;
}

export function dateToDayJs(date: Date | null | undefined): dayjs.Dayjs | null {
    return date ? dayjs(date) : null;
}

export function numberToMonth(month: number, monthFormat: any = 'MMMM'): string {
    return formatNumberToMonth(month, monthFormat);
}

/**
 * Returns the start of the following LOCAL day for use as an exclusive upper
 * bound. The input must carry the selected calendar day in the viewer's local
 * timezone, as produced by a `RangePicker` without `dateOnly`. `dateOnly` values
 * use UTC noon and must not be passed here.
 *
 * Not interchangeable with UTC day-boundary helpers: adding one calendar day in
 * the local timezone also preserves the intended day across DST transitions.
 */
export function startOfNextLocalDay(date: Date): Date {
    return DateTime.fromJSDate(date).startOf('day').plus({ days: 1 }).toJSDate();
}
